// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__rRvOw","inner":"Form_inner__1ropM","range":"Form_range__oFI2U","name":"Form_name__YqVbZ","actions":"Form_actions__3KI3N"};